import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import Page from 'src/components/Page';
import { getUser } from 'src/utils/Common';
import { makeStyles } from '@mui/styles';
import { Alert, Backdrop, Box, Button, Card, CardContent, CardHeader, Chip, Dialog, DialogActions, CircularProgress, DialogContent, DialogTitle, Grid, Autocomplete, IconButton, Snackbar, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'src/utils/axios';
import MoodBadIcon from '@mui/icons-material/MoodBad';
import TagFacesIcon from '@mui/icons-material/TagFaces';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import StoreIcon from '@mui/icons-material/Store';
import { getRegions } from 'src/store/slices/assigmentSlice';

const ALL_SERVICES = { ServisNo: 0, ServisAd: 'Tümü' };

const ORANGE = '#FF9800';
const DARK = '#424242';

const darkButtonSx = {
  color: ORANGE,
  backgroundColor: DARK,
  borderRadius: '10px',
  fontWeight: 600,
  height: '36px',
  fontSize: '13px',
  '&:hover': { backgroundColor: '#212121' }
};

const inputSx = {
  '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#fff', fontSize: '13px' },
  '& .MuiInputLabel-root': { fontSize: '13px' }
};

// Açılan liste de aynı ölçekte olsun
const listboxProps = { sx: { fontSize: '13px' } };

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Segoe UI",
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px 24px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '12px'
    }
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  card: {
    border: '1px solid #e0e0e0',
    borderRadius: '16px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    overflow: 'hidden'
  },
  cardHeader: {
    backgroundColor: '#f5f5f5',
    color: DARK,
    padding: '10px 16px',
    borderBottom: '1px solid #e0e0e0',
    '& .MuiCardHeader-title': {
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0.5px',
      textTransform: 'uppercase'
    },
    '& .MuiCardHeader-subheader': {
      fontSize: '11px',
      color: '#757575'
    }
  },
  infoBox: {
    padding: '8px 12px',
    backgroundColor: '#fafafa',
    borderRadius: '10px',
    border: '1px solid #e0e0e0',
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    position: 'relative',
    overflow: 'hidden',
    textAlign: 'center',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '3px',
      backgroundColor: ORANGE
    }
  },
  infoLabel: {
    fontWeight: '600',
    fontSize: '10px',
    color: '#546e7a',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  infoValue: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#263238'
  },
  grid: {
    border: 'none',
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#f5f5f5',
      borderBottom: '1px solid #e0e0e0'
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: '700',
      fontSize: '11px',
      color: DARK
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: '#fff8e1'
    },
    '& .MuiDataGrid-cell': {
      fontSize: '12px',
      color: '#263238'
    },
    '& .MuiDataGrid-footerContainer, & .MuiTablePagination-root, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select': {
      fontSize: '12px'
    }
  }
}));

const hasTour = (tur) => tur && tur !== '-';


function DeliveryTime() {
  const SessionUser = getUser();
  const dispatch = useDispatch();
  const classes = useStyles();

  const [tourGeneralInformations, setTourGeneralInformations] = React.useState([]);
  const [tourData, setTourData] = React.useState([]);
  const [tourTimeUpdatePopUp, setTourTimeUpdatePopUp] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [unitCode, setUnitCode] = React.useState(null);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [regionList, setRegionList] = React.useState([]);
  const [selectedRegion, setSelectedRegion] = React.useState(null);
  const [serviceList, setServiceList] = React.useState([ALL_SERVICES]);
  const [selectedService, setSelectedService] = React.useState(ALL_SERVICES);

  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = React.useState(false);
  const [responseMessage, setresponseMessage] = React.useState({
    ErrorCode: '0',
    ErrorDescription: ('success_message')
  });

  useEffect(() => {
    setLoading(true);
    dispatch(getRegions()).then((response) => {
      // İlk kayıt "Tümü"; bölge seçimi zorunlu olduğu için çıkarılır
      const regions = (response.payload || []).slice(1);
      setRegionList(regions);
      const defaultRegion = regions.find((i) => i.Id === SessionUser?.TopServiceShopCode) || null;
      setSelectedRegion(defaultRegion);
      if (defaultRegion) {
        getRegionServices(defaultRegion.Id);
      } else {
        setLoading(false);
      }
    }).catch(() => {
      setLoading(false);
    });
  }, []);

  const fetchTourPlannigList = (UstBirimKodu, ServisNo) => {
    setLoading(true);
    return axios.get(`/GetTourPlannigList/${UstBirimKodu}/${ServisNo}`)
      .then(response => {
        setLoading(false);
        return Array.isArray(response?.data) ? response.data : [];
      }).catch(() => {
        setLoading(false);
        return [];
      });
  }

  // Bölge değişince bölgenin aktif servisleri hem listeye hem Birim Kodu combosuna yüklenir
  const getRegionServices = (UstBirimKodu) => {
    setSelectedService(ALL_SERVICES);
    fetchTourPlannigList(UstBirimKodu, 0).then(data => {
      setTourGeneralInformations(data);
      setServiceList([ALL_SERVICES, ...data.map(i => ({ ServisNo: i.ServisNo, ServisAd: i.ServisAd }))]);
    });
  }

  const getTourPlannigList = () => {
    if (!selectedRegion?.Id) {
      setresponseMessage({
        ErrorCode: 1000,
        ErrorDescription: 'Lütfen Bölge Seçiniz!!!',
      });
      setUyari(true);
      return;
    }
    fetchTourPlannigList(selectedRegion.Id, selectedService?.ServisNo || 0).then(data => {
      setTourGeneralInformations(data);
    });
  }

  const getTourTimeUpdateClick = (row) => {
    var UstBirimKodu = selectedRegion?.Id || SessionUser.TopServiceShopCode
    setUnitCode(row.KUL_BIRIM_KODU)
    setSelectedRow(row)
    setTourTimeUpdatePopUp(true)
    setLoading(true);
    axios.get(`/GetTourPlannigDropdown/${UstBirimKodu}`, {
    }).then(response => {
      if (response?.data?.length > 0) {
        setTourData(response.data)
      }
      else {
        setTourData([])
      }
      setLoading(false);
    }).catch(err => {
      setLoading(false);
    });
  }

  const getTourUpdateClick = () => {
    var TurId = selectedOption?.Id
    if (selectedOption?.Id == undefined || selectedOption?.Id == null) {
      setresponseMessage({
        ErrorCode: 1000,
        ErrorDescription: 'Lütfen Tur Seçiniz!!!',
      });
      setUyari(true);
      return;
    }
    if (unitCode == undefined || unitCode == null || unitCode < 0) {
      setresponseMessage({
        ErrorCode: 1000,
        ErrorDescription: 'Lütfen Daha Sonra Tekrar Deneyiniz!!',
      });
      setUyari(true);
      return;
    }
    setLoading(true);
    axios.get(`/UpdateTourId/${TurId}/${unitCode}`, {
    }).then(response => {
      if (response.data.ErrorCode === "0") {
        setresponseMessage({
          ErrorCode: 0,
          ErrorDescription: 'İşleminiz başarılıyla gerçekleşmiştir...',
        });
        setUyari(true);
        setLoading(false);
        getTourPlannigList();
        setUnitCode(null)
        setSelectedOption(null)
        setSelectedRow(null)
        setTourTimeUpdatePopUp(false);
        return
      } else {
        setresponseMessage({
          ErrorCode: 1000,
          ErrorDescription: response.data.ErrorDescription,
        });
        setUyari(true);

        setLoading(false);
        return
      }
    }).catch(err => {
      setLoading(false);
    });

  }

  const columns = [
    {
      field: 'ServisNo',
      headerName: 'Servis No',
      width: 130,
      renderCell: (cellValues) => <Typography sx={{ fontWeight: 700, fontSize: 12 }}>{cellValues.value}</Typography>
    },
    { field: 'ServisAd', headerName: 'Servis Adı', flex: 1, minWidth: 220 },
    { field: 'Ilce', headerName: 'İlçe', width: 170 },
    { field: 'Il', headerName: 'İl', width: 150 },
    {
      field: 'Tur',
      headerName: 'Tur',
      width: 200,
      renderCell: (cellValues) => hasTour(cellValues.value)
        ? <Chip size="small" icon={<LocalShippingIcon sx={{ fontSize: 14 }} />} label={cellValues.value}
          sx={{ height: 22, fontSize: 11, borderRadius: '8px', backgroundColor: '#fff3e0', color: '#e65100', fontWeight: 600, '& .MuiChip-icon': { color: ORANGE } }} />
        : <Chip size="small" label="Tur atanmamış" variant="outlined"
          sx={{ height: 22, fontSize: 11, borderRadius: '8px', borderColor: '#ef9a9a', color: '#c62828' }} />
    },
    {
      field: 'Güncelleme',
      headerName: '',
      sortable: false,
      filterable: false,
      width: 80,
      align: 'center',
      renderCell: (cellValues) => (
        <Tooltip title="Turu güncelle">
          <IconButton
            size="small"
            sx={{ color: ORANGE, backgroundColor: DARK, borderRadius: '8px', '&:hover': { backgroundColor: '#212121' } }}
            onClick={() => { getTourTimeUpdateClick(cellValues.row); }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )
    }
  ];

  const closeTourPopUp = () => {
    setTourTimeUpdatePopUp(false);
    setSelectedOption(null);
    setSelectedRow(null);
  };

  const withoutTourCount = tourGeneralInformations.filter(i => !hasTour(i.Tur)).length;
  const summaryItems = [
    { label: 'Bölge', value: selectedRegion ? selectedRegion.Dsc : SessionUser.TopServiceShopCode },
    { label: 'Listelenen Servis', value: tourGeneralInformations.length },
    { label: 'Tur Atanmış', value: tourGeneralInformations.length - withoutTourCount },
    { label: 'Tur Atanmamış', value: withoutTourCount, alert: withoutTourCount > 0 }
  ];

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stack spacing={8}>
        <Snackbar sx={{ width: '100%' }} open={uyari} autoHideDuration={6000} onClose={uyariKapat}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
        >{responseMessage.ErrorCode === 1000 ?
          <Alert icon={<MoodBadIcon />}
            style={{ minWidth: 500 }}
            sx={{
              "& .MuiAlert-icon": {
                color: "white"
              },
              height: 75,
              alignItems: "center",
              verticalAlign: "center"

            }} onClose={uyariKapat} variant="filled" severity="error" >
            {responseMessage.ErrorDescription}
          </Alert>
          :
          <Alert icon={<TagFacesIcon />}
            style={{ minWidth: 500 }}
            sx={{
              "& .MuiAlert-icon": {
                color: "white"
              },
              height: 75,
              alignItems: "center",
              verticalAlign: "center"

            }} onClose={uyariKapat} variant="filled" severity="success" >
            {responseMessage.ErrorDescription}
          </Alert>}
        </Snackbar>
      </Stack>
      <Box className={classes.root} component={Page}>
        {/* Filtre */}
        <Card className={classes.card}>
          <CardHeader
            className={classes.cardHeader}
            avatar={<LocalShippingIcon sx={{ color: ORANGE }} />}
            title="Stok Temin Zamanı Hesaplama"
            subheader="Bölge ve birim seçerek servislerin tur bilgilerini görüntüleyin ve güncelleyin"
          />
          <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
            <Grid container spacing={1.5} alignItems="center">
              <Grid item xs={12} sm={5} md={3} lg={2.5}>
                <Autocomplete
                  options={regionList}
                  getOptionLabel={(option) => option.Dsc}
                  isOptionEqualToValue={(option, value) => option.Id === value.Id}
                  value={selectedRegion}
                  size="small"
                  fullWidth
                  onChange={(event, val) => {
                    setSelectedRegion(val);
                    if (val) {
                      getRegionServices(val.Id);
                    } else {
                      setServiceList([ALL_SERVICES]);
                      setSelectedService(ALL_SERVICES);
                      setTourGeneralInformations([]);
                    }
                  }}
                  ListboxProps={listboxProps}
                  renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" sx={inputSx} />}
                />
              </Grid>
              <Grid item xs={12} sm={5} md={3} lg={2.5}>
                <Autocomplete
                  options={serviceList}
                  getOptionLabel={(option) => option.ServisNo === 0 ? option.ServisAd : `${option.ServisNo} - ${option.ServisAd}`}
                  isOptionEqualToValue={(option, value) => option.ServisNo === value.ServisNo}
                  value={selectedService}
                  size="small"
                  fullWidth
                  disableClearable
                  disabled={!selectedRegion}
                  noOptionsText="Servis bulunamadı"
                  onChange={(event, val) => setSelectedService(val || ALL_SERVICES)}
                  ListboxProps={listboxProps}
                  renderInput={(params) => <TextField {...params} label="Birim Kodu" variant="outlined" sx={inputSx} />}
                />
              </Grid>
              <Grid item xs={12} sm={2} md={1.5}>
                <Button fullWidth startIcon={<SearchIcon />} sx={darkButtonSx} onClick={() => { getTourPlannigList() }}>
                  Ara
                </Button>
              </Grid>
            </Grid>

            <Grid container spacing={1.5} sx={{ mt: 1 }}>
              {summaryItems.map((item) => (
                <Grid item xs={6} md={3} key={item.label}>
                  <Box className={classes.infoBox}>
                    <Typography className={classes.infoLabel}>{item.label}</Typography>
                    <Typography className={classes.infoValue} sx={{ color: item.alert ? '#c62828' : undefined }} noWrap>
                      {item.value}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>

        {/* Liste */}
        <Card className={classes.card}>
          <CardHeader
            className={classes.cardHeader}
            avatar={<StoreIcon sx={{ color: ORANGE }} />}
            title="Servis Listesi"
          />
          <DataGrid
            className={classes.grid}
            style={{ height: 600, width: '100%' }}
            columns={columns}
            rows={tourGeneralInformations}
            getRowId={(rows) => rows.ServisNo}
            rowsPerPageOptions={[25, 50, 100]}
            rowHeight={42}
            headerHeight={42}
            disableSelectionOnClick
          />
        </Card>
      </Box>

      {/* Tur Güncelleme PopUp */}
      <Dialog
        open={tourTimeUpdatePopUp}
        onClose={closeTourPopUp}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: '16px' } }}
      >
        <DialogTitle className={classes.cardHeader} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '13px', fontWeight: 700, color: DARK }}>
            <LocalShippingIcon sx={{ color: ORANGE }} /> Tur Güncelle
          </Box>
          <IconButton size="small" onClick={closeTourPopUp}><CloseIcon fontSize="small" /></IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '16px !important' }}>
          {selectedRow && (
            <Grid container spacing={1.5} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={8}>
                <Box className={classes.infoBox}>
                  <Typography className={classes.infoLabel}>Servis</Typography>
                  <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#263238' }}>
                    {selectedRow.ServisNo} - {selectedRow.ServisAd}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box className={classes.infoBox}>
                  <Typography className={classes.infoLabel}>Mevcut Tur</Typography>
                  <Typography sx={{ fontSize: 12, fontWeight: 700, color: hasTour(selectedRow.Tur) ? '#263238' : '#c62828' }}>
                    {hasTour(selectedRow.Tur) ? selectedRow.Tur : 'Atanmamış'}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          )}
          <Autocomplete
            options={tourData}
            getOptionLabel={(option) => option.Tur}
            value={selectedOption}
            onChange={(event, newValue) => setSelectedOption(newValue)}
            noOptionsText="Tur bulunamadı"
            ListboxProps={listboxProps}
            renderInput={(params) => <TextField {...params} fullWidth size="small" label="Yeni Tur" sx={inputSx} />}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button sx={{ color: DARK, borderRadius: '10px', fontWeight: 600 }} onClick={closeTourPopUp}>
            Vazgeç
          </Button>
          <Button sx={{ ...darkButtonSx, height: 'auto', px: 3 }} startIcon={<EditIcon />} onClick={() => { getTourUpdateClick() }}>
            Güncelle
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DeliveryTime;
